<template>
  <form @submit.prevent="onSave" class="card p-4">
    <div class="row mb-3">
      <div class="col-auto">
        <img
          :src="profilePhoto"
          class="rounded-circle profile-avatar"
          :alt="displayName"
          width="96"
          height="96"
        />
      </div>
      <div class="col d-flex align-items-center">
        <div>
          <label class="form-label">Foto Profil</label>
          <input type="file" class="form-control" @change="onPhotoChange" accept="image/*" />
        </div>
      </div>
    </div>

    <!-- User Fields -->
    <div v-if="!isWriter">
      <div class="mb-3">
        <label class="form-label">Username</label>
        <input type="text" class="form-control" v-model="localEditUser.username" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Email</label>
        <input type="email" class="form-control" v-model="localEditUser.email" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Badge</label>
        <input type="text" class="form-control" v-model="localEditUser.badge" />
      </div>
      <div class="mb-3">
        <label class="form-label">Status Premium</label>
        <select class="form-select" v-model="localEditUser.is_premium">
          <option :value="true">Ya</option>
          <option :value="false">Tidak</option>
        </select>
      </div>
    </div>

    <!-- Author Fields -->
    <div v-else>
      <div class="mb-3">
        <label class="form-label">Nama</label>
        <input type="text" class="form-control" v-model="localEditAuthor.name" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Nomor Telepon</label>
        <input type="tel" class="form-control" v-model="localEditAuthor.phone" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Bio</label>
        <textarea class="form-control" v-model="localEditAuthor.bio" rows="3"></textarea>
      </div>
      <div class="mb-3">
        <label class="form-label">Genre</label>
        <select class="form-select" v-model="localEditAuthor.genres" multiple>
          <option v-for="g in allGenres" :key="g" :value="g">{{ g }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Pengalaman Menulis</label>
        <select class="form-select" v-model="localEditAuthor.experience_level" required>
          <option value="beginner">Pemula (0-1 tahun)</option>
          <option value="intermediate">Menengah (1-3 tahun)</option>
          <option value="experienced">Berpengalaman (3-5 tahun)</option>
          <option value="professional">Profesional (5+ tahun)</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Karya Diterbitkan</label>
        <textarea class="form-control" v-model="localEditAuthor.published_works" rows="2"></textarea>
      </div>
      <div class="mb-3">
        <label class="form-label">Website</label>
        <input type="url" class="form-control" v-model="localEditAuthor.website" />
      </div>
      <div class="mb-3">
        <label class="form-label">Instagram</label>
        <input type="text" class="form-control" v-model="localEditAuthor.instagram" />
      </div>
      <div class="mb-3">
        <label class="form-label">Twitter</label>
        <input type="text" class="form-control" v-model="localEditAuthor.twitter" />
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-outline-secondary me-2" @click="$emit('cancel')">Batal</button>
      <button type="submit" class="btn btn-primary" :disabled="saving">
        <span v-if="saving"><i class="fas fa-spinner fa-spin me-2"></i>Menyimpan...</span>
        <span v-else>Simpan</span>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'ProfileEditForm',
  props: {
    isWriter: { type: Boolean, required: true },
    editUser: { type: Object, required: true },
    editAuthor: { type: Object, required: true },
    allGenres: { type: Array, required: true },
    profilePhoto: { type: String, required: true },
    displayName: { type: String, required: true },
    saving: { type: Boolean, default: false }
  },
  emits: ['save', 'cancel', 'photo-change'],
  data() {
    return {
      localEditUser: { ...this.editUser },
      localEditAuthor: { ...this.editAuthor }
    };
  },
  watch: {
    editUser: {
      handler(val) {
        this.localEditUser = { ...val };
      },
      deep: true
    },
    editAuthor: {
      handler(val) {
        this.localEditAuthor = { ...val };
      },
      deep: true
    }
  },
  methods: {
    onSave() {
      // Emit updated values to parent
      this.$emit('save', {
        editUser: { ...this.localEditUser },
        editAuthor: { ...this.localEditAuthor }
      });
    },
    onPhotoChange(e) {
      this.$emit('photo-change', e);
    }
  }
}
</script>